import React from 'react';
import ReloadButton from '../../../features/ReloadButton/ReloadButton';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { PlusIcon } from '../../../utils/SVGIcon';
import { useApiAccessToken } from '../ApiAccessTokenProvider';

function ApiAccessTokenHeaderMobile() {
    const { handleReload } = useApiAccessToken();
    const { openModal } = useTemplate();
    return (
        <div className="input-with-filter flex justify-between items-center mb-2.5">
            <div>
                <h1 className="text-2xl font-medium">Access Token</h1>
            </div>
            {/* Action Button */}
            <div className="button-list flex items-center gap-[5px]">
                <ReloadButton className="!size-[35px] focus:outline-none" onClick={handleReload} />
                {/* Customer add */}
                <button
                    type="button"
                    onClick={() => openModal('create-new-access-token')}
                    className="size-[35px] p-[7px] bg-secondary text-white rounded-lg focus:outline-none"
                >
                    <PlusIcon />
                </button>
            </div>
        </div>
    );
}

export default ApiAccessTokenHeaderMobile;
